<div class="audio-conversation-train-question mx-auto text-center">
  {{ card().frontText || t()["train.noQuestionText"] }}
</div>

@if (canSpeakQuestion()) {
  <button
    type="button"
    class="train-front-action train-question-audio-action btn btn-icon btn-outline-primary rounded-circle waves-effect"
    [class.train-audio-action-playing]="isQuestionAudioPlaying()"
    [attr.aria-label]="t()['train.listenQuestion']"
    [title]="t()['train.listenQuestion']"
    (click)="speak.emit()"
  >
    <svg class="sa-icon sa-icon-2x sa-bold sa-nofill" aria-hidden="true">
      <use href="/assets/icons/sprite.svg#volume-2"></use>
    </svg>
  </button>
}

<div class="audio-conversation-train-audio mx-auto">
  @if (hasAudio) {
    <button
      type="button"
      class="train-front-action audio-conversation-train-speak btn btn-icon btn-outline-info rounded-circle waves-effect"
      [class.train-audio-action-playing]="isAudioPlaying()"
      [attr.aria-label]="t()['train.playAudio']"
      [title]="t()['train.playAudio']"
      (click)="playAudio.emit()"
    >
      <svg class="sa-icon sa-icon-2x sa-bold sa-nofill" aria-hidden="true">
        <use href="/assets/icons/sprite.svg#volume-2"></use>
      </svg>
    </button>
  } @else {
    <div
      class="audio-conversation-train-unavailable text-center text-body-secondary"
    >
      {{ t()["train.audioUnavailable"] }}
    </div>
  }
</div>

@if (imageAsset(); as image) {
  <div
    class="audio-conversation-train-media d-flex align-items-center justify-content-center"
  >
    <img
      class="audio-conversation-train-image img-fluid"
      [src]="image.url"
      [alt]="imageAlt"
    />
  </div>
}
